export default function test(str) {
    if (!str) return true;
    if (str === "") return false;
    // regexp based check, allow only digits
    return /^([a-zA-Z0-9]([-a-zA-Z0-9]{0,61}[a-zA-Z0-9])?\.)?([a-zA-Z0-9]{1,2}([-a-zA-Z0-9]{0,252}[a-zA-Z0-9])?)\.([a-zA-Z]{2,63})$/.test(str);
}
